import { ApplicantCreditCheckAction } from '../ApplicantCreditCheckAction'
import {
  APPLICANT_CREDIT_CHECK_ACTION_ORDER,
  APPLICANT_CREDIT_CHECK_SENSITIVE_ACTIONS,
} from '../ApplicantCreditCheckBlock.constants'
import {
  useApplicantCreditCheckDocument,
  useApplicantCreditCheckRequest,
  useApplicantCreditCheckVerdict,
} from '../ApplicantCreditCheckBlock.hooks'

import * as styles from './ApplicantCreditCheckActions.module.css'

function ApplicantCreditCheckActions({ applicantData, isPreview }) {
  const { handleOpenGate } = useApplicantCreditCheckRequest()

  const { handleOpenVerdictForm } = useApplicantCreditCheckVerdict()

  const {
    handleFinishUpload,
    handleStartUpload,
    handleUploadErrors,
    isSubmitting,
  } = useApplicantCreditCheckDocument()

  function handleClickAction(action) {
    return APPLICANT_CREDIT_CHECK_SENSITIVE_ACTIONS.includes(action)
      ? handleOpenVerdictForm(action)
      : handleOpenGate(action)
  }

  return (
    <div className={styles.ApplicantCreditCheckActions}>
      {APPLICANT_CREDIT_CHECK_ACTION_ORDER.map(action => (
        <ApplicantCreditCheckAction
          action={action}
          applicantData={applicantData}
          isPreview={isPreview}
          isSubmitting={isSubmitting}
          key={action}
          onClick={handleClickAction}
          onFinishUpload={handleFinishUpload}
          onStartUpload={handleStartUpload}
          onUploadErrors={handleUploadErrors}
        />
      ))}
    </div>
  )
}

export default ApplicantCreditCheckActions
